import { Loading } from 'components/core-v2/pages'
import { Navigate } from 'react-router-dom'

import { PATH } from '../const'
import { useUser } from '../utilities/hooks/useUser'

export const Home = () => {
  const { data: userData, isError, isSuccess } = useUser()

  if (isSuccess && userData) {
    if (userData.roles.includes('PortfolioManager') && userData.roles.length === 1) {
      return <Navigate to={PATH.productAdminPortfolios} />
    }
    return <Navigate to={PATH.reportsOverview} />
  }

  if (isError) {
    return <Navigate to={PATH.login} />
  }

  return <Loading />
}
